export default "__VITE_ASSET__DnYNTVN$__"